// extracted by mini-css-extract-plugin
export var parcelRow = "_rf-0";